export default "__VITE_ASSET__DAAF5inq__"